// Суммы приходят строками Decimal ("1990.00")
export function formatMoney(value) {
    const number = Number(value || 0)
    return `${number.toLocaleString('ru-RU', {maximumFractionDigits: 2})} ₽`
}

export function formatDate(value) {
    if (!value) {
        return ''
    }
    const date = new Date(value)
    if (isNaN(date.getTime())) {
        return ''
    }
    return date.toLocaleDateString('ru-RU', {year: 'numeric', month: 'long', day: 'numeric'})
}

export function plural(n, one, few, many) {
    const mod10 = n % 10
    const mod100 = n % 100
    if (mod10 === 1 && mod100 !== 11) {
        return one
    }
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) {
        return few
    }
    return many
}

export function formatMonths(months) {
    return `${months} ${plural(months, 'месяц', 'месяца', 'месяцев')}`
}

export function formatDays(days) {
    return `${days} ${plural(days, 'день', 'дня', 'дней')}`
}

const PRODUCT_NAMES = {
    profit: 'Профит',
}

export function productName(code) {
    return PRODUCT_NAMES[code] || code
}

const LIMIT_NAMES = {
    product: 'Товары',
    store: 'Магазины',
    strategy: 'Стратегии',
    user: 'Пользователи',
    tracked_offers: 'Цены на витрине',
}
const LIMIT_ORDER = Object.keys(LIMIT_NAMES)

export function limitName(key) {
    return LIMIT_NAMES[key] || key
}

export function sortEntitlements(entitlements) {
    const index = (key) => {
        const position = LIMIT_ORDER.indexOf(key)
        return position === -1 ? LIMIT_ORDER.length : position
    }
    return (entitlements || []).slice().sort((a, b) => index(a.key) - index(b.key))
}

const SUBSCRIPTION_STATUSES = {
    trialing: {label: 'Пробный период', class: 'bg-label-info'},
    active: {label: 'Активна', class: 'bg-label-success'},
    past_due: {label: 'Не оплачена', class: 'bg-label-warning'},
    canceled: {label: 'Отменена', class: 'bg-label-secondary'},
    expired: {label: 'Закончилась', class: 'bg-label-danger'},
    free: {label: 'Бесплатный', class: 'bg-label-secondary'},
}

export function subscriptionStatus(status) {
    return SUBSCRIPTION_STATUSES[status] || {label: status, class: 'bg-label-secondary'}
}

const INVOICE_STATUSES = {
    issued: {label: 'Ожидает оплаты', class: 'bg-label-warning'},
    paid: {label: 'Оплачен', class: 'bg-label-success'},
    void: {label: 'Отменён', class: 'bg-label-secondary'},
    expired: {label: 'Просрочен', class: 'bg-label-danger'},
    refunded: {label: 'Возвращён', class: 'bg-label-secondary'},
}

export function invoiceStatus(status) {
    return INVOICE_STATUSES[status] || {label: status, class: 'bg-label-secondary'}
}

const INVOICE_KINDS = {
    new: 'Подписка',
    renewal: 'Продление',
    change: 'Смена тарифа',
}

export function invoiceKind(kind) {
    return INVOICE_KINDS[kind] || kind
}

const METHODS = {
    card: 'Картой или СБП',
    bank_transfer: 'По счёту',
}

export function methodName(method) {
    return METHODS[method] || method
}

// Как оплачена подписка (billing_method) — для фразы «Оплачена: …»
const BILLING_METHODS = {
    card: 'картой или через СБП',
    bank_transfer: 'по счёту',
}

export function billingMethodName(method) {
    return BILLING_METHODS[method] || method
}

const PAYER_TYPES = {
    legal: 'Организация или ИП',
    individual: 'Физическое лицо',
}

export function payerTypeName(payer_type) {
    return PAYER_TYPES[payer_type] || payer_type
}

// Причины отказа ЮKassa (payment.cancellation_details.reason)
const CANCELLATION_REASONS = {
    insufficient_funds: 'недостаточно средств',
    card_expired: 'истёк срок действия карты',
    expired_on_confirmation: 'истекло время на подтверждение оплаты',
    '3d_secure_failed': 'не пройдена проверка 3-D Secure',
    call_issuer: 'банк отклонил платёж, обратитесь в банк',
    general_decline: 'банк отклонил платёж',
    payment_method_restricted: 'операции по карте ограничены',
    payment_method_limit_exceeded: 'превышен лимит по карте',
    country_forbidden: 'оплата картой этой страны недоступна',
    fraud_suspected: 'платёж заблокирован из-за подозрения в мошенничестве',
    permission_revoked: 'разрешение на списание отозвано',
    canceled_by_merchant: 'платёж отменён',
    invalid_card_number: 'неверный номер карты',
    invalid_csc: 'неверный CVV/CVC',
}

export function cancellationReason(reason) {
    if (!reason) {
        return ''
    }
    return CANCELLATION_REASONS[reason] || reason
}

// Последний платёж счёта (по времени создания)
export function lastPayment(invoice) {
    const payments = (invoice && invoice.payments) || []
    return payments.slice().sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0] || null
}

// Счёт картой, который можно оплатить (в том числе повторно после отказа или просрочки)
export function canPayByCard(invoice) {
    return invoice.method === 'card' && ['issued', 'expired'].includes(invoice.status)
}
